var _path, _circle, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTicketSearchBottomNav = function SvgTicketSearchBottomNav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ticket-search-bottom-nav_svg__a)",
    d: "m16.174 2.5.707-.25-.177-.5h-.53zM19 4.5h.75v-.75H19zm0 11v.75h.75v-.75zm-2.826 2v.75h.53l.177-.5zm-12.348 0-.707.25.177.5h.53zM1 15.5H.25v.75H1zm0-11v-.75H.25v.75zm2.826-2v-.75h-.53l-.177.5zm12.348 0-.707.25A3.75 3.75 0 0 0 19 5.25v-1.5c-.977 0-1.81-.624-2.12-1.5zM19 4.5h-.75v11h1.5v-11zm0 11v-.75a3.75 3.75 0 0 0-3.533 2.5l.707.25.707.25A2.25 2.25 0 0 1 19 16.25zm-2.826 2v-.75H3.826v1.5h12.348zm-12.348 0 .707-.25A3.75 3.75 0 0 0 1 14.75v1.5c.977 0 1.81.625 2.12 1.5zM1 15.5h.75v-11H.25v11zm0-11v.75a3.75 3.75 0 0 0 3.533-2.5l-.707-.25-.707-.25A2.25 2.25 0 0 1 1 3.75zm2.826-2v.75h12.348v-1.5H3.826z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 2.5,
    stroke: "url(#ticket-search-bottom-nav_svg__b)",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "url(#ticket-search-bottom-nav_svg__c)",
    strokeWidth: 1.5,
    d: "m13.5 13.5-3-3"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ticket-search-bottom-nav_svg__a",
    x1: 23.647,
    x2: 12.833,
    y1: 3.701,
    y2: 19.446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#FF7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#15CFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3BF2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#6675FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ticket-search-bottom-nav_svg__b",
    x1: 12.791,
    x2: 9,
    y1: 6.9,
    y2: 11.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#FF7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#15CFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3BF2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#6675FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ticket-search-bottom-nav_svg__c",
    x1: 14.274,
    x2: 12,
    y1: 10.74,
    y2: 13.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.126,
    stopColor: "#FF7880"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#15CFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.625,
    stopColor: "#3BF2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.876,
    stopColor: "#6675FF"
  })))));
};
export { SvgTicketSearchBottomNav as ReactComponent };
export default "data:image/svg+xml;base64,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";